// NavbarDesktop.jsx
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { HomeIcon, LogoutIcon, MessagesIcon, NotificationIcon, NotificationsIcon, ProfileSettingIcon, SettingIcon, SmileyWink, ProfileNavIcon } from "Components/icons/Icons";
import { ELEMENT_IDS } from "constants/constants";
import { stopTour } from "states/guideTour/guideTourSlice";

// import { HomeIcon } from "lucide-react";

export default function NavbarDesktopV2({
    dropdownOpen,
    dropdownBox,
    handleNotificationPress,
    handleLogOutPress,
    setErrors,
    setLogInOptions,
    setShowPassword,
    setShowConfirmPassword,
    setModalType,
    setSignUpOptions,
    setRole,

}) {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pathname = location.pathname;

    const {
        user,
        token,
    } = useSelector((state) => state.auth);
    const { unReadMessagesCount } = useSelector((state) => state.chat);

    const avatarUrl = user && user?.brand && user?.brand !== null
        ? user?.brand.profile_image_thumb !== null
            ? user?.brand.profile_image_thumb
            : "/assets/images/user.png"
        : user && user?.creator && user?.creator !== null
            ? user?.creator.profile_image_thumb !== null
                ? user?.creator.profile_image_thumb
                : "/assets/images/user.png"
            : "/assets/images/user.png"


    const activeUserRoutes = [
        "/brandProfile",
        "/brandSetting",
        "/creatorsSetting",
        "/creatorsProfile",
    ];

    const isUserUrlActive = activeUserRoutes.includes(pathname);

    const isLogin = user !== null;

    const navbarItems = [
        {
            label: "Home",
            link: "/",
            //  roles: ["1"], 
            icon: <HomeIcon />,
            iconActive: <></>,
            onClick: () => {
                navigate("/");
            }
        },
        {
            label: "Notifications",
            //  link: "/creatorChat", 
            //  roles: ["1"], 
            icon: <NotificationsIcon />,
            //   iconActive: <NotificationsIcon />,
            onClick: () => {
                handleNotificationPress();
            }
        },
        {
            label: "Messages",
            link: "/creatorChat",
            // roles: ["1"],
            icon: <MessagesIcon />,
            iconActive: <MessagesIcon isActive={true} />,
            onClick: () => {
                navigate("/creatorChat");
            }
        },
        //
        // { label: "Notifications", link: "/creatorChat", roles: ["2"], icon: <NotificationsIcon />, iconActive: <NotificationsIcon /> },
        // { label: "Messages", link: "/creatorChat", roles: ["2"], icon: <NotificationsIcon />, iconActive: <NotificationsIcon /> },
    ];

    return (

        <div
            //  ${false ? "d-md-flex" : "d-none"}
            className={`--collapse --navbar-collapse tw-flex`}
            id="navbarSupportedContent"
        >
            <ul className={`navbar-nav tw-flex-row tw-m-auto  max-[320px]:tw-pt-0 tw-pt-3 sm:tw-mr-3 ${!isLogin && "tw-hidden"}`}>
                <div className="tw-flex tw-justify-between">
                    <div className={`tw-flex tw-gap-2 ${unReadMessagesCount ? "tw-mr-[10px] sm:tw-mr-0" : ""}`}>
                        {navbarItems.map((navbarItem) => (
                            <li
                                className={`nav-item nav-li tw-flex tw-relative `}
                                // ${location.pathname === navbarItem.link ? "active" : ""}
                                key={`outer-nav-${navbarItem.label}`}
                            >
                                <button
                                    className="tw-text-black 
                                    tw-block 
                                    tw-px-[7px] 
                                    tw-py-0 
                                    tw-mb-[10px] 
                                    tw-no-underline 
                                    tw-relative"
                                    onClick={navbarItem.onClick}
                                >
                                    {(navbarItem.link && location.pathname === navbarItem.link) ? navbarItem.iconActive : navbarItem.icon}
                                </button>
                                {unReadMessagesCount && navbarItem.label === "Messages" ? (
                                    <div
                                        className="
                                        tw-absolute 
                                        tw--top-1 
                                        tw--right-1 
                                        tw-bg-red-500 
                                        tw-text-white 
                                        tw-rounded-full 
                                        tw-w-5 tw-h-5 
                                        tw-flex tw-items-center tw-justify-center 
                                        tw-text-xs tw-font-bold"
                                    >
                                        {unReadMessagesCount}
                                    </div>
                                ) : null}
                            </li>
                        ))}
                    </div>
                    <div className="col-4 d-none d-md-flex"></div>
                </div>
            </ul>

            <ul className="tw-m-0 tw-items-center
            tw-hidden sm:tw-flex">
                <div>
                    {token !== "" && user !== null ? (
                        <>
                            <div className="user-dropdown-box" onClick={dropdownOpen}>
                                {/* <div
                                    onClick={() => { }
                                    }
                                    className="nav-icon tw-me-4 tw-flex tw-justify-center tw-items-center">
                                    <img
                                        id="avatar-button"
                                        src={avatarUrl}
                                        className="img-fluid pointer-cursor tw-object-cover tw-h-[55px] tw-w-[55px]"
                                        alt="User"
                                    />
                                </div> */}
                                <ProfileNavIcon className="tw-mr-3" avatarUrl={avatarUrl} isActive={isUserUrlActive} />
                                <div className="inner-dropdown" onClick={dropdownBox}>
                                    <div onClick={dropdownOpen}>
                                        {user?.role === "1" ? (
                                            <>
                                                <Link
                                                    id="menu-profile-link"
                                                    to="/creatorsProfile"
                                                    onClick={() => {
                                                        dispatch(stopTour());
                                                    }}
                                                >

                                                    <div
                                                        // id="menu-profile-link"
                                                        className="d-flex dropdown-text-style">
                                                        <div className="me-2">
                                                            <ProfileSettingIcon />
                                                        </div>
                                                        Profile
                                                    </div>
                                                </Link>
                                                <Link
                                                    onClick={() => {
                                                        handleNotificationPress();
                                                    }}
                                                >
                                                    <div className="d-flex dropdown-text-style">
                                                        <div className="me-2">
                                                            <NotificationIcon />
                                                        </div>
                                                        Notifications
                                                    </div>
                                                </Link>
                                                <Link to="/creatorsSetting">
                                                    <div className="d-flex dropdown-text-style">
                                                        <div className="me-2">
                                                            <SettingIcon />
                                                        </div>
                                                        Settings
                                                    </div>
                                                </Link>
                                            </>
                                        ) : (
                                            <>
                                                <Link to="/brandProfile">
                                                    <div className="d-flex  dropdown-text-style">
                                                        <div className="me-2">
                                                            <SettingIcon />
                                                        </div>
                                                        Profile
                                                    </div>
                                                </Link>
                                                <Link
                                                    onClick={() => {
                                                        handleNotificationPress();
                                                    }}
                                                >
                                                    <div className="d-flex dropdown-text-style">
                                                        <div className="me-2">
                                                            <NotificationIcon />
                                                        </div>
                                                        Notifications
                                                    </div>
                                                </Link>
                                                <Link to="/brandSetting">
                                                    <div className="d-flex dropdown-text-style">
                                                        <div className="me-2">
                                                            <SettingIcon />
                                                        </div>
                                                        Settings
                                                    </div>
                                                </Link>
                                            </>
                                        )}
                                        <Link
                                            onClick={() => {
                                                handleLogOutPress();
                                            }}
                                        >
                                            <div className="d-flex dropdown-text-style">
                                                <div className="me-2">
                                                    <LogoutIcon />
                                                </div>
                                                Logout
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                id={ELEMENT_IDS.BTN_LOG_IN_FROM_LP}
                                className="nav-icon me-4 d-flex justify-content-center align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#logInModal"
                                onClick={() => {
                                    setErrors([]);
                                    setLogInOptions(true);
                                    setShowPassword(false);
                                }}
                            >
                                <img
                                    src="/assets/images/enter.png"
                                    className="img-fluid"
                                    alt="login"
                                />
                            </div>
                        </>
                    )}
                </div>
                <div className="button-box d-none d-md-flex">
                    {user !== null ? (
                        user?.role === "2" ? (
                            <>
                                <button
                                    onClick={() => navigate("/addCampaigns", { state: { from: location.pathname } })}
                                    className="--btn --common-button-style-filled tw-btn-gradient tw-px-4 tw-mr-3"
                                    type="button"
                                >
                                    Create Campaign
                                </button>
                            </>
                        ) : null
                    ) : (
                        <>
                            <div id="brand-sign-up-from-LP"
                                data-bs-toggle="modal"
                                data-bs-target="#signUpModal"
                                onClick={() => {
                                    setErrors([]);
                                    setShowPassword(false);
                                    setShowConfirmPassword(false);
                                    setModalType("signUpAsBrand");
                                    setSignUpOptions(false);
                                    setRole(2);
                                }}></div>

                            <div
                                className="d-none d-md-flex flex-row cursor-pointer gap-4 align-items-center justify-content-end w-33">
                                <div
                                    id={ELEMENT_IDS.BTN_SIGN_UP_FROM_LP}
                                    data-bs-toggle="modal"
                                    data-bs-target="#signUpModal"
                                    onClick={() => {
                                        setErrors([]);
                                        setShowPassword(false);
                                        setShowConfirmPassword(false);
                                        setModalType("signUpAsCreator");
                                        setSignUpOptions(false);
                                        setRole(1);
                                    }}
                                    className="d-flex flex-row gap-2 tw-bg-primary px-4 py-2 rounded">
                                    <span className="fw-semibold text-white">Join as Creator</span>
                                    <SmileyWink />
                                </div>
                                <a href="/mainHelp" class="text-decoration-none">
                                    <div class="bg-white tw-border tw-border-primary px-4 py-2 rounded">
                                        <span class="fw-semibold tw-text-primary">Support</span>
                                    </div>
                                </a>
                            </div>
                        </>
                    )}
                </div>
            </ul>
        </div>
    )

}